import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { usersAPIUrls } from '../data';

export const deleteUser = withLogger(async (userId: string): Promise<true> => {
  const url = `${usersAPIUrls.delete}/${userId}`;
  await authAxiosClient.delete(url);
  return true;
});
